import { render } from "./WebsiteUri.vue?vue&type=template&id=04e47b07"
import script from "./WebsiteUri.vue?vue&type=script&lang=js"
export * from "./WebsiteUri.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__